import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'procure-post-footer',
  templateUrl: './post-footer.component.html',
  styleUrl: './post-footer.component.scss',
  changeDetection: ChangeDetectionStrategy.Eager,
})
export class PostFooter {}
